import React from 'react'
import { docDict } from '../../../helpers/constant'
import FilePdfIcon from '../../../images/file.svg'

export const Documents: React.FC = () => {
  const ofretaDocs = docDict.oferta
  const licenseDocs = docDict.licenses
  return (
    <div className='onlinepbx__documents'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center'>Документы</h2>
          <div className='onlinepbx__documents__container'>
            <div className='onlinepbx__documents__content'>
              {ofretaDocs.map((document) => (
                <div key={document.link} className='onlinepbx__documents__block'>
                  <a className='onlinepbx__documents__link' target='_blank' href={document.link}>
                    <div className='onlinepbx__documents__format'>
                      {document.format === 'PDF' && <FilePdfIcon className='onlinepbx__documents__format__icon' />}
                    </div>
                    <div className='onlinepbx__documents__title'>{document.title}</div>
                  </a>
                </div>
              ))}
            </div>
            <div className='onlinepbx__documents__separator' />
            <div className='onlinepbx__documents__content'>
              {licenseDocs.map((document) => (
                  <div key={document.link} className='onlinepbx__documents__block'>
                    <a className='onlinepbx__documents__link' target='_blank' href={document.link}>
                      <div className='onlinepbx__documents__format'>
                        {document.format === 'PDF' && <FilePdfIcon className='onlinepbx__documents__format__icon' />}
                      </div>
                      <div className='onlinepbx__documents__title'>{document.title}</div>
                    </a>
                  </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Documents
